import React from 'react';
import ImgPhoto from "../../../../resources/console/images/icon/default-user.svg";
import btnMoreinfo from "../../../../resources/preReg/images/icon/btn-moreinfo.svg";

// 사용자 컴포넌트 - SessionList.Detail.UserList.js와 동일한 레이아웃 적용
const User = (props) => {
  const { item, setSessionMgrInfoModal, eventIdx } = props;
  const isBilingual = eventIdx == 1098 || eventIdx == 1199;
  const mgrLabel = item?.mgrType === "SEAT"
    ? (isBilingual ? "Chair" : "좌장")
    : item?.mgrType === "PANEL"
      ? (isBilingual ? "Pannel" : "패널")
      : (isBilingual ? "Speaker" : "연자");
  return (
    <div className="slide_flex" onClick={(e) => setSessionMgrInfoModal(true, item)} >
      <div className="slide_flex_div">
        <div className="slide_flex_inner_div">
          <img
            className="slide_img"
            src={item.signedUrlPhoto || ImgPhoto}
            alt="프로필사진"
          />
          <img
            className="slide_img_more"
            src={btnMoreinfo}
            alt="더보기"
          />
        </div>
      </div>
      <div className="slide_flex_t">
        <b>
          {mgrLabel}
        </b>
        <h2>{item?.name}</h2>
        <p>
          {item?.brieflyMark ? item?.brieflyMark : (
            <>
              {item.companyName && <span>{item.companyName}</span>}
              {item.deptName && <span>{item.deptName}</span>}
            </>
          )}
        </p>
      </div>
    </div>
  )
}

export default User;